var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefultMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_433)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_327_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5925 11.5272C18.6804 10.5423 17.4063 10 16 10C14.5863 10 13.308 10.5391 12.4 11.5178C11.4822 12.5073 11.035 13.8522 11.14 15.3044C11.3482 18.1694 13.5283 20.5 16 20.5C18.4718 20.5 20.6482 18.1698 20.8596 15.3053C20.966 13.8662 20.516 12.5242 19.5925 11.5272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98624 31.3523C6.20762 31.4526 6.44891 31.503 6.69256 31.4999L16 34L25.3074 31.4999C25.5511 31.5029 25.7924 31.4524 26.0138 31.3521C26.2352 31.2517 26.4311 31.104 26.5872 30.9197C26.931 30.515 27.0695 29.9624 26.9669 29.4035C26.5206 26.965 25.1276 24.9166 22.9383 23.4791C20.9932 22.2031 18.5294 21.5 16 21.5C13.4706 21.5 11.0068 22.2026 9.06173 23.4791C6.87237 24.9171 5.47942 26.9656 5.03309 29.4041C4.9305 29.9629 5.06905 30.5155 5.41279 30.9202C5.56896 31.1044 5.76486 31.252 5.98624 31.3523Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#D1D5DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_433"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_327_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefultMy);
export default __webpack_public_path__ + "static/media/defult_my.79dc15aec4fd32fce939f51487fd54cc.svg";
export { ForwardRef as ReactComponent };